// This enum must match with DepositAnalytics.CalculationsLibrary\Models\Recalculation\RecalculationTrigger.cs
// https://www.lucidchart.com/invitations/accept/89e7a69f-2bcb-4dd3-b9fe-45af6df85592
// tslint:disable-next-line:max-line-length
// Design document: https://empyrean-solutions.visualstudio.com/Deposit%20Analytics/_wiki/wikis/Deposit-Analytics.wiki/74/User-Story-6107-Stable-Balance-Recalculation-triggers-for-stable-balances

export enum RecalculationTrigger {
  DataMonthlyAppend = 0,
  ProductDataReImport = 1,
  ProductDataReImportAfterCalibrationEndDate = 2,
  ProductDefinitionChange = 3,
  CalibrationEndDateChange = 4,
  ForecastBalancesChange = 5,
  ForecastEndDateChange = 6,
  ForecastBalancesAndEndDateChange = 7,
  MarketRateForecastChange = 8,
  MarketRateDataReImport = 9,
  CalibrationSave = 10,
  CalibrationApprove = 11,
  CalibrationSaveApprove = 12,
  MonthlyAppendWithForecastEndChange = 13,
  EOPDateClearanceOrTruncation = 14,
  AccountCharacteristicsUpdate = 15
}

export const RecalculationTriggerName = {
  [RecalculationTrigger.DataMonthlyAppend]: 'Data Monthly Append',
  [RecalculationTrigger.ProductDataReImport]: 'Product Data Re-Import',
  [RecalculationTrigger.ProductDataReImportAfterCalibrationEndDate]: 'Product Data Re-Import after Calibration End Date changed',
  [RecalculationTrigger.ProductDefinitionChange]: 'Product Definition Change',
  [RecalculationTrigger.CalibrationEndDateChange]: 'Calibration End Date changed',
  [RecalculationTrigger.ForecastBalancesChange]: 'Forecast Balances changed',
  [RecalculationTrigger.ForecastEndDateChange]: 'Forecast End Date changed',
  [RecalculationTrigger.ForecastBalancesAndEndDateChange]: 'Forecast Balances and End Date changed',
  [RecalculationTrigger.MarketRateForecastChange]: 'Market Rate Forecast changed',
  [RecalculationTrigger.MarketRateDataReImport]: 'Market Rate Data Re-Import',
  [RecalculationTrigger.CalibrationSave]: 'Calibration Saved',
  [RecalculationTrigger.CalibrationApprove]: 'Calibration Approved',
  [RecalculationTrigger.CalibrationSaveApprove]: 'Calibration Saved and Approved',
  [RecalculationTrigger.MonthlyAppendWithForecastEndChange]: 'Data Monthly Append and Forecast Balances changed',
  [RecalculationTrigger.EOPDateClearanceOrTruncation]: 'Removal of Deposits Observation Dates',
  [RecalculationTrigger.AccountCharacteristicsUpdate]: 'Account Characteristics Update'
};
